export enum SERVICE_TYPES {
  Assessment = 'Assessment',
  Ongoing = 'Ongoing',
}
